"use client";

import { Link } from "react-router-dom";
import { useLanguage } from "@/i18n/LanguageContext";

export default function ArticleHeader() {
  const { t } = useLanguage();
  return (
    <section className="py-12 bg-white">
      <nav className="mb-4">
        <Link to="/blog/" className="text-sm text-[#047857] hover:text-[#ea580c]">
          Blog
        </Link>
        <span className="text-sm text-gray-400 mx-2">&gt;</span>
        <span className="text-sm text-gray-500">{t("blog.shutters.breadcrumb")}</span>
      </nav>

      <span className="inline-block bg-[#fbbf24] text-[#064e3b] uppercase tracking-widest text-xs px-3 py-1 rounded">
        {t("blog.shutters.breadcrumb")}
      </span>

      <h1 className="mt-4 text-4xl font-bold text-[#064e3b] leading-tight">
        {t("blog.shutters.h1")}
      </h1>

      <p className="mt-4 text-sm text-gray-500">
        {t("blog.shutters.readTime")}
      </p>

      <img
        src="https://static.readdy.ai/image/60b7a1bdc124301cce40c5bb19c672c9/00d180c1689cdb4f6525735b32a0fa32.jpeg"
        alt={t("blog.shutters.imgAlt") as string}
        className="mt-8 w-full rounded-xl object-cover"
        width={1000}
        height={500}
        onError={(e) => {
          (e.target as HTMLImageElement).src =
            "https://placehold.co/1000x500/064e3b/fbbf24?text=Comparison";
        }}
      />
    </section>
  );
}